import { add } from "ramda";
import {
  getLiterageRequiredForConfigurableAreaList,
  sumOfNonConfigurableAreaLiterages,
} from "./areaListFns";

export default (areas) => {
  return add(
    getLiterageRequiredForConfigurableAreaList(areas),
    sumOfNonConfigurableAreaLiterages(areas)
  );
};
